// src/onboarding/ui/formStyles.js — the wizard's control look (theme tokens only, the console's sizes).
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

export const LABEL = {
  display: 'block', fontSize: '11px', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase',
  color: COLORS.textSecondary, marginBottom: '6px', fontFamily: FONT_SANS,
};
export const INPUT = (invalid = false) => ({
  width: '100%', boxSizing: 'border-box', height: '46px', padding: '0 14px', borderRadius: RADII.control,
  border: `1px solid ${invalid ? SEMANTIC.errore.fg : COLORS.border}`, background: COLORS.surface,
  fontFamily: FONT_SANS, fontSize: '14px', color: COLORS.ink,
});
export const HINT = { fontSize: '12px', color: COLORS.textTertiary, margin: '6px 0 0', lineHeight: 1.5 };
export const FIELD = { marginBottom: '20px' };
export const PRIMARY = (disabled = false) => ({
  height: '46px', padding: '0 22px', borderRadius: RADII.control, border: 'none',
  background: disabled ? COLORS.borderStrong : COLORS.accent, color: COLORS.surface,
  fontFamily: FONT_SANS, fontSize: '14px', fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
});
export const SECONDARY = {
  height: '46px', padding: '0 18px', borderRadius: RADII.control, border: `1px solid ${COLORS.borderStrong}`,
  background: COLORS.surface, color: COLORS.ink, fontFamily: FONT_SANS, fontSize: '14px', fontWeight: 600,
  cursor: 'pointer', textDecoration: 'none', display: 'inline-flex', alignItems: 'center',
};
export const NOTE = (sem) => ({
  padding: '12px 14px', borderRadius: RADII.control, background: sem.bg, color: sem.fg,
  fontFamily: FONT_SANS, fontSize: '13px', lineHeight: 1.55, margin: '0 0 16px',
});
export const ACTIONS = { display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', marginTop: '8px' };
